// Action Types
export const WALL_BUILDER_ACTIONS = {
    SET_WALL_TYPE: 'SET_WALL_TYPE',
    SET_ZOOM: 'SET_ZOOM',
    SET_SELECTED_BLOCK: 'SET_SELECTED_BLOCK',
    SET_VIEW_MODE: 'SET_VIEW_MODE',
    SET_GLOBAL_STONE_IDS: 'SET_GLOBAL_STONE_IDS',
    SET_IS_ADDING_TO_CART: 'SET_IS_ADDING_TO_CART',
    // Segment actions
    ADD_SEGMENT: 'ADD_SEGMENT',
    REMOVE_SEGMENT: 'REMOVE_SEGMENT',
    UPDATE_SEGMENT: 'UPDATE_SEGMENT',
    UPDATE_SEGMENT_NAME: 'UPDATE_SEGMENT_NAME',
    UPDATE_SEGMENT_CORNER_STONES: 'UPDATE_SEGMENT_CORNER_STONES',
    UPDATE_SEGMENT_TOP_STONE: 'UPDATE_SEGMENT_TOP_STONE',
    UPDATE_SEGMENT_STARTING_STONE: 'UPDATE_SEGMENT_STARTING_STONE',
    UPDATE_SEGMENT_END_STONE: 'UPDATE_SEGMENT_END_STONE',
    UPDATE_SEGMENT_TOP_CORNER_STONE: 'UPDATE_SEGMENT_TOP_CORNER_STONE',
    REORDER_SEGMENTS: 'REORDER_SEGMENTS',
    // Reset actions
    RESET_SEGMENTS: 'RESET_SEGMENTS',
    RESET_ALL: 'RESET_ALL',
};
